import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
} from "react-native";

import Fonts from "../../Resources/Fonts";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";

import { useTranslation } from "react-i18next";
// import { useScreenDimensions } from "..";
import { useScreenDimensions, useDevice } from "../_layout";

const DeleteBlockView = ({
  isVisible,
  title,
  text,
  action,
  onClose,
  nameOfBlock,
}) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const predefinedText = nameOfBlock ? nameOfBlock : "Nombre del bloque";
  const [blockName, setBlockName] = useState("");

  const isNameMatch =
    blockName.trim().toLowerCase() === nameOfBlock.trim().toLowerCase();

  const Save = () => {
    if (isNameMatch) {
      action();
      onClose();
    }
  };
  const Buttons = ({ bool }) => {
    const text = bool ? "delete-string" : "cancel-string";
    const [isHovered, setIsHovered] = useState(false);

    const isDeleteButton = bool;
    const isDisabled = isDeleteButton && !isNameMatch;

    return (
      <TouchableOpacity
        onPress={bool ? Save : onClose}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: bool ? "red" : Colors.whiteColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: "red",
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
            opacity: isDisabled ? 0.5 : 1,
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: bool ? Colors.whiteColor : "red",
              fontWeight: isHovered ? "600" : "normal",
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={onClose}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{ position: "absolute" }}
          onStartShouldSetResponder={() => false}
        >
          <View
            style={[
              styles.modalView,
              {
                backgroundColor: Colors.whiteColor,
                maxWidth: screenSize === "small" ? 300 : 400,
                padding: 24, // Ensure there is padding to prevent text touching the borders
              },
            ]}
          >
            <View style={{ alignItems: "center", gap: 8 }}>
              <Text style={Fonts.bold18Centered}>{t(title)}</Text>
              <Text
                style={{
                  textAlign: "center",
                  color: Colors.blackColor,
                  width: "100%",
                  flexShrink: 1,
                }}
              >
                {t(text)}
              </Text>
            </View>
            <TextInput
              style={[
                GlobalStyles.textInputStyle,
                {
                  borderColor: isHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                },
              ]}
              placeholder={predefinedText}
              placeholderTextColor={Colors.grayColor}
              value={blockName}
              onChangeText={setBlockName}
              onSubmitEditing={() => Save()}
              maxLength={70}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            />
            <View
              style={[
                GlobalStyles.HStack,
                {
                  justifyContent: "center",
                  width: "100%",
                  justifyContent: "space-around",
                  marginTop: 20,
                },
              ]}
            >
              <Buttons bool={false} />
              <Buttons bool={true} />
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center", // Center the modal horizontally
  },

  modalView: {
    // minWidth: 300,
    // maxWidth: "80%",
    alignSelf: "center",
    backgroundColor: Colors.whiteColor,
    borderRadius: 18,
    paddingHorizontal: 24,
    paddingVertical: 24,
    // alignItems: "center",
    // justifyContent: "space-between",
  },

  touchableBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(15, 15, 15, 0.2)",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default DeleteBlockView;
